@if (tags$ | async; as tags) {
  @if (tags?.length) {
    <div class="profile-info small">
      @if (revealed) {
        <div class="profile-info__decoration">
          <div class="profile-info__icon-wrapper">
            <svg width="16" height="16" class="icon higher">
              <use xlink:href="#tags"></use>
            </svg>
          </div>
        </div>
      }
      <div
        appCardBlockCollapse
        class="candidate-tags view-only card-collapse-block"
        [revealedInfo]="revealedCardInfo$ | async"
        [visibleRowNumber]="visibleRowNumber"
        [gap]="gap">
        @for (tag of tags; track tag; let i = $index) {
          <app-tag [tag]="tag" [viewOnly]="true" appCardBlockItemCollapse></app-tag>
        }
        <span class="collapse-sign">...</span>
      </div>
    </div>
  }
}
